import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { NavLink } from 'react-router-dom';
import { List, ListItem, ListItemText } from '@material-ui/core';

import { FEATURE_FLAG_NAMES } from 'yeself-common/typings/FeatureFlags';

import { ROUTES } from 'Console/constants/routes';

const styles = (theme) => ({
    root: {
        flexGrow: 1,
        alignItems: 'center',
        'border-right': '1px solid #ccc',
        [theme.breakpoints.down('sm')]: {
            'border-right': 0,
        },
    },
    navLink: {
        display: 'flex',
        textDecoration: 'none',
        '& :hover': {
            'background-color': theme.palette.hoverBackground.backgroundColor,
        },
    },
    navLinkActive: {
        'background-color': theme.palette.hoverBackground.backgroundColor,
    },
    listItem: {
        'padding-left': 10,
        '& :hover': {
            'background-color': 'unset',
        },
        [theme.breakpoints.down('sm')]: {
            'padding-left': 24,
        },
    },
    listItemText: {
        color: theme.palette.sixth.color,
        'font-size': 14,
        'line-height': 1,
        '& :hover': {
            'background-color': 'unset',
        },
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
});

const NavSider = ({ classes, intl, routePrefix, featureFlags }) => {
    const { formatMessage } = intl;
    const listItems = [
        {
            navLinkTo: ROUTES.CONTEXT_HELP_SETTINGS,
            displayName: formatMessage({
                id: 'ContextHelp.navigation.settings',
            }),
        },
    ];

    if (featureFlags[FEATURE_FLAG_NAMES.CONTEXT_HELP_COMPOSITION]) {
        listItems.push({
            navLinkTo: ROUTES.CONTEXT_HELP_COMPOSITION,
            displayName: formatMessage({
                id: 'ContextHelp.navigation.composition',
            }),
        });
    }

    return (
        <List id="yeself-nav-sider" className={classes.root} component="nav">
            {listItems.map((item) => (
                <NavLink
                    id="yeself-nav-sider-navlink-item"
                    key={`setting-sidebar-navlink-item-${item.displayName}`}
                    className={classes.navLink}
                    to={`${routePrefix}${item.navLinkTo}`}
                    activeClassName={classes.navLinkActive}
                >
                    <ListItem
                        id="yeself-nav-sider-item"
                        key={`setting-sidebar-item-${item.displayName}`}
                        className={classes.listItem}
                        button
                    >
                        <ListItemText
                            primaryTypographyProps={{ className: classes.listItemText }}
                            primary={item.displayName}
                        />
                    </ListItem>
                </NavLink>
            ))}
        </List>
    );
};

export default withStyles(styles)(NavSider);
